module.exports = __webpack_public_path__ + "img/icon-proveedores.4d877f3b.svg";